import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./RankingsChartStyles";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  ReferenceLine,
  XAxis,
  CartesianGrid,
  LabelList
} from "recharts";
import { colour } from "../style/base-theme";
import RankingsAxisTick from "../components/RankingsAxisTick";
import RankingReferenceLabel from "../components/RankingReferenceLabel";

export default class RankingsChart extends Component {
  render() {
    let {
      summary,
      cost,
      consumption,
      generation,
      currency_unit,
      period: { time_unit }
    } = this.props;

    if (cost) cost.name = "Cost";
    if (consumption) consumption.name = "Consumption";
    if (generation) generation.name = "Generation";

    let title = time_unit
      .toLowerCase()
      .split(" ")
      .map(function(word) {
        return word.replace(word[0], word[0].toUpperCase());
      })
      .join(" ");

    if (generation) {
      title = `${title}ly Ranking by Cost, Consumption & Generation`;
    } else {
      title = `${title}ly Ranking by Cost & Consumption`;
    }

    return (
      <Fragment>
        <div className={css(styles.summary)}>{summary}</div>
        <div className={css(styles.chartWrapper)}>
          <div className={css(styles.titleWrapper)}>
            <span className={css(styles.chartTitle)}>{`${title}`}</span>
          </div>
          <ResponsiveContainer
            className={css(
              generation ? styles.chart3Column : styles.chart2Column
            )}
          >
            <ComposedChart
              width={600}
              height={300}
              data={[cost]}
              barSize={15}
              barGap={10}
              margin={{ top: 80, right: 35, left: 35, bottom: 30 }}
            >
              <XAxis
                dataKey="name"
                interval={0}
                tick={<RankingsAxisTick data={this.props} />}
                tickLine={false}
                stroke={colour.grey[400]}
                fontFamily="Source Sans Pro"
              />
              <CartesianGrid
                stroke={colour.grey[500]}
                vertical={false}
                x={0}
                width={500}
              />
              <Bar type="monotone" dataKey={`you`} fill={colour.brand.purple}>
                <LabelList
                  valueAccessor={entry =>
                    `${currency_unit}${entry.you.toFixed(2)}`
                  }
                  position="top"
                  fill={colour.brand.purple}
                  fontSize={12}
                  fontWeight={600}
                />
              </Bar>
              <Bar type="monotone" dataKey={`similar`} fill={colour.grey[400]}>
                <LabelList
                  valueAccessor={entry =>
                    `${currency_unit}${entry.similar.toFixed(2)}`
                  }
                  position="top"
                  fill={colour.grey[400]}
                  fontSize={12}
                  fontWeight={600}
                />
              </Bar>
              <ReferenceLine
                y={cost && cost[`all`]}
                stroke={colour.grey[200]}
                strokeWidth={2}
                label={
                  <RankingReferenceLabel
                    value={`${currency_unit}${cost && cost[`all`].toFixed(2)}`}
                    fill={colour.grey[200]}
                  />
                }
                strokeDasharray="2 2"
                isFront={true}
              />
            </ComposedChart>
          </ResponsiveContainer>
          <ResponsiveContainer
            className={css(
              generation ? styles.chart3Column : styles.chart2Column
            )}
          >
            <ComposedChart
              width={600}
              height={300}
              data={[consumption]}
              barSize={15}
              barGap={10}
              margin={{ top: 80, right: 35, left: 35, bottom: 30 }}
            >
              <XAxis
                dataKey="name"
                interval={0}
                tick={<RankingsAxisTick data={this.props} />}
                tickLine={false}
                stroke={colour.grey[400]}
                fontFamily="Source Sans Pro"
              />
              <CartesianGrid
                stroke={colour.grey[500]}
                vertical={false}
                x={0}
                width={500}
              />
              <Bar type="monotone" dataKey={`you`} fill={colour.brand.purple}>
                <LabelList
                  valueAccessor={entry => `${entry.you.toFixed(2)}`}
                  position="top"
                  fill={colour.brand.purple}
                  fontSize={12}
                  fontWeight={600}
                />
              </Bar>
              <Bar type="monotone" dataKey={`similar`} fill={colour.grey[400]}>
                <LabelList
                  valueAccessor={entry => `${entry.similar.toFixed(2)}`}
                  position="top"
                  fill={colour.grey[400]}
                  fontSize={12}
                  fontWeight={600}
                />
              </Bar>
              <ReferenceLine
                y={consumption && consumption[`all`]}
                stroke={colour.grey[200]}
                strokeWidth={2}
                label={
                  <RankingReferenceLabel
                    value={consumption && consumption[`all`].toFixed(2)}
                    fill={colour.grey[200]}
                  />
                }
                strokeDasharray="2 2"
                isFront={true}
              />
            </ComposedChart>
          </ResponsiveContainer>
          {generation && (
            <ResponsiveContainer
              className={css(
                generation ? styles.chart3Column : styles.chart2Column
              )}
            >
              <ComposedChart
                width={600}
                height={300}
                data={[generation]}
                barSize={15}
                barGap={10}
                margin={{ top: 80, right: 35, left: 35, bottom: 30 }}
              >
                <XAxis
                  dataKey="name"
                  interval={0}
                  tick={<RankingsAxisTick data={this.props} />}
                  tickLine={false}
                  stroke={colour.grey[400]}
                  fontFamily="Source Sans Pro"
                />
                <CartesianGrid
                  stroke={colour.grey[500]}
                  vertical={false}
                  x={0}
                  width={500}
                />
                <Bar type="monotone" dataKey={`you`} fill={colour.brand.purple}>
                  <LabelList
                    valueAccessor={entry => `${entry.you.toFixed(2)}`}
                    position="top"
                    fill={colour.brand.purple}
                    fontSize={12}
                    fontWeight={600}
                  />
                </Bar>
                <Bar
                  type="monotone"
                  dataKey={`similar`}
                  fill={colour.grey[400]}
                >
                  <LabelList
                    valueAccessor={entry => `${entry.similar.toFixed(2)}`}
                    position="top"
                    fill={colour.grey[400]}
                    fontSize={12}
                    fontWeight={600}
                  />
                </Bar>
                <ReferenceLine
                  y={generation && generation[`all`]}
                  width={100}
                  stroke={colour.grey[200]}
                  strokeWidth={2}
                  label={
                    <RankingReferenceLabel
                      value={generation && generation[`all`].toFixed(2)}
                      fill={colour.grey[200]}
                    />
                  }
                  strokeDasharray="2 2"
                  isFront={true}
                />
              </ComposedChart>
            </ResponsiveContainer>
          )}
          <div className={css(styles.legend)}>
            <p>
              <img
                className={css(styles.img)}
                src="/icons/InformetisIcon.png"
                width={20}
                height={20}
              />
              You
            </p>
            <p>
              <img
                className={css(styles.img)}
                src="/icons/HomeIconGrey.svg"
                width={20}
                height={20}
              />
              Similar homes to you
            </p>
            <p>
              <i className={css(styles.line)} />
              All homes
            </p>
          </div>
        </div>
      </Fragment>
    );
  }
}
